import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const querySchema = z.object({
  chapter: z.string().optional(),
});

export const Route = createFileRoute('/curriculum/books/$bookId')({
  validateSearch: querySchema,
});
